import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Capabilities from "@/pages/Capabilities";
import RequestQuote from "@/pages/RequestQuote";
import PastProjects from "@/pages/PastProjects";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/request-a-quote" element={<RequestQuote />} />
            <Route path="/projects" element={<PastProjects />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
